import { EmbeddedContentDefinition } from 'modules/graphql';
import { FieldNames } from 'modules/templateEditor/common';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useValidateContentField } from 'modules/templateEditor/hooks/useValidateContentField';
import { DISPLAY_CONTENT } from '../constants';
import { InputTextField } from './components';

const { formMediaUrlLabel, urlPlaceholder } = DISPLAY_CONTENT.settings;

export const MediaUrl = () => {
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const embeddedData = liveTemplate.mediumData as EmbeddedContentDefinition;
  const elements = embeddedData?.elements;
  const mediaUrl = elements?.mediaUrl || '';

  const { hasError, errorText } = useValidateContentField(FieldNames.ATTACHMENT_URL);

  const setMediaUrl = (updatedUrl: string) => {
    const newElements = {
      ...elements,
      mediaUrl: updatedUrl.length ? updatedUrl : null,
    };
    setCurrentMediumField('elements', newElements);
  };

  return (
    <InputTextField
      label={formMediaUrlLabel}
      value={mediaUrl}
      setValue={setMediaUrl}
      errorText={errorText}
      hasError={hasError}
      placeholder={urlPlaceholder}
    />
  );
};
